(function () {
  // Only on PDP
  if (!/\/products\//.test(window.location.pathname)) return;

  // Prevent multiple init (theme hydration / soft nav)
  if (window.__MYKOS_STICKY_ATC_INIT_V7__) return;
  window.__MYKOS_STICKY_ATC_INIT_V7__ = true;

  // ----------------------------
  // Utils
  // ----------------------------
  function cleanText(s) {
    return String(s || "").replace(/\s+/g, " ").trim();
  }

  function isActuallyVisible(el) {
    if (!el) return false;
    const r = el.getBoundingClientRect?.();
    if (!r || r.width <= 1 || r.height <= 1) return false;

    const cs = window.getComputedStyle ? getComputedStyle(el) : null;
    if (cs) {
      if (cs.display === "none") return false;
      if (cs.visibility === "hidden") return false;
      if (Number(cs.opacity || 1) === 0) return false;
    }

    if (el.offsetParent === null && cs && cs.position !== "fixed") return false;

    return true;
  }

  function getVariantFromUrl() {
    try {
      const u = new URL(window.location.href);
      const v = (u.searchParams.get("variant") || "").trim();
      return /^\d+$/.test(v) ? v : "";
    } catch (e) {
      return "";
    }
  }

  // ----------------------------
  // Force styles (wins vs theme CSS)
  // ----------------------------
  function ensureStyles() {
    if (document.getElementById("mykos-sticky-atc-style")) return;

    const style = document.createElement("style");
    style.id = "mykos-sticky-atc-style";
    style.textContent = `
      .sticky-atc{
        position:fixed !important;
        z-index:2147483647 !important;
        display:block !important;
        visibility:visible !important;
        opacity:1 !important;

        left:0 !important;
        right:0 !important;
        bottom:0 !important;

        background:rgba(255,255,255,0.96) !important;
        backdrop-filter: blur(10px) !important;
        border-top:1px solid rgba(0,0,0,0.08) !important;

        padding:12px 14px calc(12px + env(safe-area-inset-bottom)) !important;

        transform: translateY(110%) !important;
        transition: transform 220ms ease !important;

        pointer-events:none !important;
      }

      .sticky-atc.is-visible{
        transform: translateY(0) !important;
        pointer-events:auto !important;
      }

      .sticky-atc__row{
        display:grid !important;
        grid-template-columns: 1fr auto !important;
        gap:12px !important;
        align-items:center !important;
        min-height:44px !important;
      }

      .sticky-atc__meta{
        display:flex !important;
        align-items:center !important;
        gap:10px !important;
        min-width:0 !important;
      }

      .sticky-atc__thumb{
        width:44px !important;
        height:44px !important;
        border-radius:10px !important;
        overflow:hidden !important;
        background: rgba(0,0,0,0.04) !important;
        flex: 0 0 auto !important;
        border: 1px solid rgba(0,0,0,0.08) !important;
      }

      .sticky-atc__thumb img{
        width:100% !important;
        height:100% !important;
        object-fit:cover !important;
        display:block !important;
      }

      .sticky-atc__text{
        min-width:0 !important;
      }

      .sticky-atc__title{
        font-size:14px !important;
        font-weight:600 !important;
        white-space:nowrap !important;
        overflow:hidden !important;
        text-overflow:ellipsis !important;
      }

      .sticky-atc__sub{
        font-size:12px !important;
        opacity:0.75 !important;
        white-space:nowrap !important;
        overflow:hidden !important;
        text-overflow:ellipsis !important;
        margin-top:2px !important;
      }

      .sticky-atc__btn{
        border:0 !important;
        border-radius:999px !important;
        padding:12px 16px !important;
        font-size:14px !important;
        font-weight:700 !important;
        cursor:pointer !important;
        white-space:nowrap !important;

        background:#415356 !important;
        color:#ffffff !important;
      }

      @media (hover:hover){
        .sticky-atc__btn:hover{ filter: brightness(1.08); }
      }

      @media (min-width:1025px){
        .sticky-atc{
          left:50% !important;
          right:auto !important;
          bottom:18px !important;

          width:min(920px, calc(100vw - 48px)) !important;
          max-width:920px !important;

          padding:12px 14px !important;
          border-radius:14px !important;
          border:1px solid rgba(0,0,0,0.10) !important;
          box-shadow: 0 10px 30px rgba(0,0,0,0.10) !important;

          transform: translate(-50%, 110%) !important;
        }
        .sticky-atc.is-visible{
          transform: translate(-50%, 0) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // ----------------------------
  // Find main PDP form + real ATC
  // ----------------------------
  function findPrimaryFormAndATC() {
    const forms = Array.from(document.querySelectorAll('form[action^="/cart/add"]'));

    function isGoodForm(f) {
      return (
        !!f.querySelector('input[name="id"]') &&
        !!f.querySelector('button[type="submit"], input[type="submit"]')
      );
    }

    function scoreForm(f) {
      if (!isGoodForm(f)) return -9999;
      let score = 0;

      if (f.closest("main")) score += 5;
      if (f.closest("product-info")) score += 5;
      if (f.closest('[id*="MainProduct"]')) score += 4;
      if (f.closest('[data-section-type*="product"]')) score += 4;
      if (f.closest("[data-section-id]")) score += 2;

      if (f.closest("header")) score -= 6;
      if (f.closest("[role='dialog'], .drawer, .modal")) score -= 6;
      if (f.closest(".sticky-atc")) score -= 50;

      const submits = Array.from(
        f.querySelectorAll('button[type="submit"], input[type="submit"]')
      );
      if (submits.some(isActuallyVisible)) score += 3;

      return score;
    }

    let best = null;
    let bestScore = -9999;
    for (const f of forms) {
      const s = scoreForm(f);
      if (s > bestScore) {
        bestScore = s;
        best = f;
      }
    }

    const productForm = best || forms.find(isGoodForm);
    if (!productForm) return null;

    const idInput = productForm.querySelector('input[name="id"]');
    if (!idInput) return null;

    const submitCandidates = Array.from(
      productForm.querySelectorAll('button[type="submit"], input[type="submit"]')
    );

    const primaryATC = submitCandidates.find(isActuallyVisible) || submitCandidates[0];
    if (!primaryATC) return null;

    return { productForm, idInput, primaryATC };
  }

  const ctx = findPrimaryFormAndATC();
  if (!ctx) return;

  const { productForm, idInput, primaryATC } = ctx;

  // ----------------------------
  // De-dupe adds (submit + click handlers)
  // ----------------------------
  let addLock = false;
  let lastAddAt = 0;

  function lockAdd(ms = 1200) {
    addLock = true;
    lastAddAt = Date.now();
    setTimeout(() => { addLock = false; }, ms);
  }

  productForm.addEventListener(
    "submit",
    (e) => {
      const now = Date.now();
      if (addLock && now - lastAddAt < 1200) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      lockAdd();
    },
    true
  );

  primaryATC.addEventListener(
    "click",
    (e) => {
      const now = Date.now();
      if (addLock && now - lastAddAt < 1200) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
    },
    true
  );

  // ----------------------------
  // Sticky UI
  // ----------------------------
  ensureStyles();

  const existing = document.querySelector(".sticky-atc");
  if (existing) existing.remove();

  const sticky = document.createElement("div");
  sticky.className = "sticky-atc";
  sticky.innerHTML = `
    <div class="sticky-atc__row">
      <div class="sticky-atc__meta">
        <div class="sticky-atc__thumb" aria-hidden="true">
          <img data-sticky-thumb alt="" />
        </div>
        <div class="sticky-atc__text">
          <div class="sticky-atc__title" data-sticky-title></div>
          <div class="sticky-atc__sub" data-sticky-sub></div>
        </div>
      </div>
      <button class="sticky-atc__btn" type="button" data-sticky-btn>Add to Cart</button>
    </div>
  `;
  document.body.appendChild(sticky);

  const titleEl = sticky.querySelector("[data-sticky-title]");
  const subEl = sticky.querySelector("[data-sticky-sub]");
  const btnEl = sticky.querySelector("[data-sticky-btn]");
  const thumbImg = sticky.querySelector("[data-sticky-thumb]");
  const thumbWrap = sticky.querySelector(".sticky-atc__thumb");

  const h1 = document.querySelector("h1");
  if (titleEl) titleEl.textContent = h1 ? cleanText(h1.textContent) : "Add to cart";

  // ----------------------------
  // Selected image thumbnail
  // ----------------------------
  function pickFromImg(img) {
    if (!img) return "";
    const src =
      img.currentSrc ||
      img.getAttribute("src") ||
      img.getAttribute("data-src") ||
      "";
    return cleanText(src);
  }

  function findActiveProductImageUrl() {
    // Try a bunch of "active media" patterns across Shopify themes
    const selectors = [
      // Dawn-ish / media-gallery patterns
      'media-gallery [aria-current="true"] img',
      'media-gallery .is-active img',
      '.product__media-item.is-active img',
      '.product__media-item[aria-current="true"] img',
      '.product__media-item--active img',
      '.product__media-list .is-active img',
      // Generic “active slide” patterns
      '.swiper-slide-active img',
      '.splide__slide.is-active img',
      '.keen-slider__slide[aria-current="true"] img',
      '.flickity-slider .is-selected img',
      // Common product image containers
      '.product__media img',
      '.product-media img',
      '.product-gallery img',
      '.product__gallery img',
      'main img[src*="/products/"]'
    ];

    for (const sel of selectors) {
      const img = document.querySelector(sel);
      const src = pickFromImg(img);
      if (src) return src;
    }

    // Fallback to OG image
    const og = document.querySelector('meta[property="og:image"], meta[name="og:image"]');
    const ogc = og ? og.getAttribute("content") : "";
    if (ogc) return cleanText(ogc);

    return "";
  }

  function setThumb(url) {
    const u = cleanText(url);
    if (!thumbImg || !thumbWrap) return;

    if (!u) {
      thumbWrap.style.display = "none";
      return;
    }

    // Only update if changed (prevents flicker)
    if (thumbImg.__lastSrc === u) return;
    thumbImg.__lastSrc = u;

    thumbWrap.style.display = "";
    thumbImg.src = u;
  }

  function syncThumb() {
    const url = findActiveProductImageUrl();
    setThumb(url);
  }

  // ----------------------------
  // Better option reading (selected Color/Size, not full list)
  // ----------------------------
  function isListLikeValue(v) {
    const s = cleanText(v);
    if (!s) return true;

    const tokens = s.split(/\s+/).filter(Boolean);
    if (tokens.length >= 8) return true;
    if (s.includes(",") && tokens.length >= 5) return true;

    const digitCount = (s.match(/\d/g) || []).length;
    if (digitCount >= 10) return true;

    return false;
  }

  function getSelectedOptionFromSelectors(label) {
    const scope = productForm || document;

    const fieldsets = Array.from(scope.querySelectorAll("fieldset"));
    for (const fs of fieldsets) {
      const legend = fs.querySelector("legend");
      const ltxt = cleanText(legend && legend.textContent);
      if (!ltxt || !ltxt.toLowerCase().includes(label.toLowerCase())) continue;

      const checked =
        fs.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      if (checked) {
        const lab = checked.id
          ? fs.querySelector(`label[for="${CSS.escape(checked.id)}"]`)
          : null;
        const val = cleanText(lab ? lab.textContent : checked.value);
        if (val && !isListLikeValue(val)) return val;
      }
    }

    const selects = Array.from(scope.querySelectorAll("select"));
    for (const sel of selects) {
      const wrap =
        sel.closest(".select, .field, .product-form__input, .form__input-wrapper") ||
        sel.parentElement;

      const nearLabel = wrap ? wrap.querySelector("label") : null;
      const nearText = cleanText(nearLabel && nearLabel.textContent);

      const name = (sel.getAttribute("name") || "").toLowerCase();
      const hitByName =
        name.includes(label.toLowerCase()) ||
        name.includes("options[") ||
        name.includes("option");

      const hitByLabel = nearText && nearText.toLowerCase().includes(label.toLowerCase());

      if (hitByName || hitByLabel) {
        const opt =
          sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
        const val = cleanText(opt ? opt.textContent : sel.value);
        if (val && !isListLikeValue(val)) return val;
      }
    }

    return "";
  }

  function readDisplayedOption(label) {
    const main = document.querySelector("main") || document;
    const nodes = Array.from(main.querySelectorAll("*"));
    const wanted = label + ":";

    for (const el of nodes) {
      const t = cleanText(el.textContent);
      if (!t) continue;
      if (t.startsWith(wanted)) {
        const v = cleanText(t.slice(wanted.length));
        if (v && v.length < 80 && !isListLikeValue(v)) return v;
      }
    }
    return "";
  }

  function syncMeta() {
    const colorSel = getSelectedOptionFromSelectors("Color");
    const sizeSel = getSelectedOptionFromSelectors("Size");

    const color = colorSel || readDisplayedOption("Color");
    const size = sizeSel || readDisplayedOption("Size");

    if (subEl) {
      subEl.textContent = cleanText(
        [color && `Color: ${color}`, size && `Size: ${size}`].filter(Boolean).join(" · ")
      );
    }

    if (btnEl) {
      const label =
        (primaryATC.tagName === "INPUT" ? primaryATC.value : primaryATC.textContent) ||
        "Add to Cart";
      btnEl.textContent = cleanText(label);
    }
  }

  // ----------------------------
  // Variant syncing
  // ----------------------------
  function setVariantIdOnForm(vid) {
    const v = cleanText(vid);
    if (!/^\d+$/.test(v)) return;

    idInput.value = v;
    try { idInput.dispatchEvent(new Event("input", { bubbles: true })); } catch (e) {}
    try { idInput.dispatchEvent(new Event("change", { bubbles: true })); } catch (e) {}
  }

  // ----------------------------
  // Sticky click (single add)
  // ----------------------------
  let busy = false;
  let lastClickAt = 0;

  btnEl.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      const now = Date.now();
      if (busy) return;
      if (now - lastClickAt < 650) return;
      lastClickAt = now;

      busy = true;

      const original = btnEl.textContent;
      btnEl.textContent = "Adding…";
      btnEl.disabled = true;

      try {
        const vid = getVariantFromUrl() || cleanText(idInput.value);
        setVariantIdOnForm(vid);
        primaryATC.click();
      } catch (err) {
        console.warn("[sticky-atc] error:", err);
      } finally {
        setTimeout(() => {
          btnEl.disabled = false;
          btnEl.textContent = original || "Add to Cart";
          busy = false;
        }, 450);
      }
    },
    true
  );

  // ----------------------------
  // Show/hide based on inline ATC visibility
  // ----------------------------
  const io = new IntersectionObserver(
    (entries) => {
      const entry = entries && entries[0];
      const inView = !!(entry && entry.isIntersecting && entry.intersectionRatio > 0.02);
      sticky.classList.toggle("is-visible", !inView);
    },
    { root: null, rootMargin: "0px 0px -120px 0px", threshold: [0, 0.02, 0.1] }
  );

  try { io.observe(primaryATC); } catch (e) {}

  // ----------------------------
  // Keep meta + thumb in sync
  // ----------------------------
  let rafPending = false;
  function syncAll() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      rafPending = false;
      syncMeta();
      syncThumb();
    });
  }

  const mo = new MutationObserver(() => syncAll());
  mo.observe(document.querySelector("main") || document.body, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
  });

  // Also refresh thumb on typical gallery interactions
  document.addEventListener("click", () => setTimeout(syncThumb, 60), true);
  window.addEventListener("resize", () => setTimeout(syncThumb, 60), true);

  // Initial sync + initial visibility decision (before IO fires)
  syncAll();

  setTimeout(() => {
    const r = primaryATC.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight || 0;
    const inView = r.top < vh && r.bottom > 0;
    sticky.classList.toggle("is-visible", !inView);
    syncThumb();
  }, 80);
})();
